import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { connect } from 'react-redux'
import CustomerForm from './customerForm'
import BackButton from '../../../components/BackButton'

const ManageCustomer = (props: any) => {
    const [isEdit, setIsEdit] = useState(false);

    const { id } = useParams();
    useEffect(() => {
        if (id) {
            setIsEdit(true);
        } else {
            setIsEdit(false);
        }
    }, []);
    return (
        <div className="container-fluid profile-width-control">
            <div className="page-header">
                <h1>{isEdit ? 'Customer Profile' : 'Create Customer'}</h1>
                <BackButton/>
            </div>

            <CustomerForm  isEdit={isEdit} customerId={id}></CustomerForm>
        </div>
    )
}

const mapStateToProps = (state: any) => {
    return ({
        isLoading: state.common.isLoading
    })
}

export default connect(mapStateToProps, null)(ManageCustomer)
